import { EmailDateRange } from 'services';

export interface Period {
  title: string;
  /** Janela móvel terminando hoje. */
  days?: number;
  /** 0 = mês atual, 1 = mês passado. */
  monthsAgo?: number;
  /** Habilita os campos de data no formulário. */
  custom?: boolean;
}

export const PERIODS: Period[] = [
  { title: 'Últimos 7 dias', days: 7 },
  { title: 'Últimos 30 dias', days: 30 },
  { title: 'Últimos 90 dias', days: 90 },
  { title: 'Mês atual', monthsAgo: 0 },
  { title: 'Mês passado', monthsAgo: 1 },
  { title: 'Data personalizada', custom: true },
];

const MS_PER_DAY = 86400000;

const toDayString = (date: Date) => {
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * Converte o período escolhido na janela `{ from, to }` em `YYYY-MM-DD`.
 * Retorna `null` quando o período é personalizado e falta uma das datas —
 * cabe a quem chama avisar o usuário em vez de consultar com filtro incompleto.
 */
export const resolvePeriodRange = (period: Period, startDate: string, endDate: string): EmailDateRange | null => {
  if (period.custom) {
    return startDate && endDate ? { from: startDate, to: endDate } : null;
  }

  const today = new Date();

  if (period.days) {
    const since = new Date(today.getTime() - (period.days - 1) * MS_PER_DAY);
    return { from: toDayString(since), to: toDayString(today) };
  }

  const month = new Date(today.getFullYear(), today.getMonth() - (period.monthsAgo ?? 0), 1);
  const lastDay = new Date(month.getFullYear(), month.getMonth() + 1, 0);
  return { from: toDayString(month), to: toDayString(lastDay) };
};
